/* eslint-disable formatjs/no-literal-string-in-jsx */
/* eslint-disable react/jsx-no-literals */
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ROOT_URL } from '../../environment';
import { DEVICE_SETTINGS_STORAGE_KEY } from '../sessions/vonage/deviceSettingsStorage';

export const Redirect = ({ match }) => {
  useEffect(() => {
    const id = match.params.appointment_id;

    let devicePreferences;
    try {
      devicePreferences = localStorage.getItem(DEVICE_SETTINGS_STORAGE_KEY);
    } catch (error) {
      // Storage failures must not block authentication.
    }
    try {
      localStorage.clear();
      if (devicePreferences !== null && devicePreferences !== undefined) {
        localStorage.setItem(DEVICE_SETTINGS_STORAGE_KEY, devicePreferences);
      }
    } catch (error) {
      // Continue to token assignment/navigation when storage is restricted.
    }
    try {
      localStorage.setItem('token', match.params.token);
    } catch (error) {
      // Navigation still proceeds; downstream auth will handle a missing token.
    }
    setTimeout(
      () =>
        window.location.replace(
          `${ROOT_URL}/sessions/clients/video_call/${id}`,
        ),
      500,
    );
  }, []);

  const id = match.params.appointment_id;
  return (
    <div style={{ textAlign: 'center', marginTop: '10%' }}>
      <p style={{ fontSize: '40px' }}>
        Click{' '}
        <a href={`${ROOT_URL}/sessions/clients/video_call/${id}`}>here</a> if
        you are not automatically directed in 5 seconds...
      </p>
    </div>
  );
};

const mapStateToProps = () => ({});

Redirect.propTypes = {
  match: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(Redirect);
